import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import { MapPin } from "lucide-react";

export default function MapPage() {
  const { t } = useI18n();
  return (
    <main className="min-h-screen" data-testid="map-page">
      <section className="mx-auto max-w-7xl px-6 lg:px-10 pt-28 pb-10">
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--brand-primary)] font-bold mb-4">Location</p>
        <h1 className="font-display text-stone-900 text-5xl sm:text-7xl tracking-tight">{t("map_title")}</h1>
        <p className="mt-4 text-stone-600 text-lg max-w-2xl">26.0989° N · 34.2786° E — between Hurghada and Marsa Alam on Egypt's Red Sea coast.</p>
      </section>
      <section className="mx-auto max-w-7xl px-6 lg:px-10 pb-24">
        <div className="rounded-3xl overflow-hidden border border-stone-200 shadow-sm aspect-[16/10]">
          <iframe
            title="Al Quseir map"
            width="100%"
            height="100%"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.openstreetmap.org/export/embed.html?bbox=34.20%2C26.05%2C34.36%2C26.15&layer=mapnik&marker=26.0989%2C34.2786"
            data-testid="map-iframe"
          />
        </div>
        <div className="mt-6 inline-flex items-center gap-2 text-sm text-stone-600">
          <MapPin className="h-4 w-4 text-[var(--brand-primary)]" /> Al Quseir, Red Sea Governorate, Egypt
        </div>
      </section>
    </main>
  );
}
